import { TrustBand } from "@/components/marketplace"
import type { FeedSection } from "@/features/feed/contract"
import type { FeedSectionProps } from "@/features/feed/sections/types"

export const TrustPanelFeedSection = ({ section }: FeedSectionProps<Extract<FeedSection, { type: "TRUST_PANEL" }>>) => {
  const { title, image, eyebrow, sub, pill } = section.data
  if (!title || !image?.url) return null
  return <TrustBand title={title} image={image.url} imageCrop={image} imageAlt={image.alt ?? ""} eyebrow={eyebrow} sub={sub} pill={pill} />
}
